import { ActionNodeActionProxy } from '..'

import { RemoveProperties } from './RemoveProperties'

export class RemovePropertiesProxy extends ActionNodeActionProxy {
  action: RemoveProperties

  constructor(action: RemoveProperties) {
    super()
    this.action = action
  }

  getModel(): RemoveProperties {
    return this.action
  }

  setIdentifiers(ids: Array<number>): void {
    this.action.identifiers = ids
  }

  isActionValid() {
    return this.action.identifiers.length > 0
  }
}
